import { SimpleResponse } from "./AudioVedioRecorder/genericResponse.model";

export interface Presentation {
  scId: number,
  accountId: number,
  userId: number,
  title: string;
  status: number,
  inactiveSlideImage: string;
  inactiveSlideHTML: string;
  inactiveSlideJSON: string;
  emailSubject: string;
  isAllowAnonymous: boolean;
  isShowScript: boolean;
  defaultPresentation: boolean;
  defaultQuickLaunch: boolean;
  defaultQuickBroadcast: boolean;
  slides: Slide[];
  image: string;
  dtCreated: string;
}

export interface VIP {
  vipId: number;
  clpCompanyId: number;
  clpUserId: number;
  vipTitle: string;
  status: number;
  inActiveSlideHtml: string;
  emailSubject: string;
  isAllowAnonymous: boolean;
  isShowScript: boolean;
  dtCreated: string;
  ctOnStart: number;
  ctOnEnd: number;
  sgWebFormID: number;
  sgQrCodeUrl: string;
  siteAnalytics: string
  userFullName: string;
  sgLinkCode: string;
  vBubblePosition: string
  vBubbleShape: string;
}

export interface PresentationResponse {
  broadcastUrl: string;
  vip: VIP[];
}

export interface Slide {
  slideId: number;
  scId: number;
  accountId: number;
  userId: number;
  slideTitle: string;
  contentType: number;
  content: string;
  json: string;
  sOrder: number;
  link: string;
  script: string;
  image: string;
  imageExt: string;
  mediaId: number;
  mediaData: string;
  tempId: string;
  add: boolean;
  update: boolean;
  delete: boolean;
}

export interface VIPSlide {
  vipSlideId: number;
  vipId: number;
  slideTitle: string;
  contentType: number;
  content: any;
  sorder: number;
  dtCreated: string | null;
  link: string;
  script: string;
  imageBankId: number;
  audio: string;
  audioSeconds: number;
  vedio: string;
  vedioSeconds: number;
  vipSlidecategoryCode: number;
}

export interface VIPSlideCategory {
  vipSlideCategoryCode: number;
  clpCompanyId: number;
  display: string;
  sorder: number;
}

export interface VIPSlideCategory extends SimpleResponse{
  vipSlideList: VIPSlide[];
}

export interface VIPSlideCategoryListResponse extends SimpleResponse {
  vipSlideCategoryList: VIPSlideCategory[];
}

export interface SlideVideo {
  vipSlideId: number,
  vipId: number,
  audio: string,
  audioSeconds: number,
  video: string,
  videoSeconds: number,
  fullVideo: string,
  fullAudio: string,
  vBubbleURL: string,
  vBubbleShape: number,
  mediaType: number,
}

export interface ProcessCheck {
    id: number,
    status: string,
    processed: boolean
}

export interface ExportVideoRecording {
    isRecordingType: number,
    recordingSrc: string,
}
